export async function interceptRequestForAppWithSyncTesting({
	url,
}: {
	url: string;
}): Promise<void> {
	const { mksapDebugSyncDisabled, mksapDebugFakeOffline } = window as any;

	if (mksapDebugSyncDisabled && url.includes("/api/sync.json")) {
		throw new Error("sync disabled");
	} else if (mksapDebugFakeOffline && !isContentUrl(url)) {
		// Simulate offline mode for all requests except content URLs.
		// The content is baked into the apps, so those requests should
		// still work even when offline.
		throw new Error("fake offline");
	}
}

function isContentUrl(url: string): boolean {
	const pathFragments = [
		"/api/questions/",
		"/api/topics/",
		"/api/figures/",
		"/api/tables/",
		"/api/front_matters/",
		"/api/content_metadata.json",
	];
	for (const pathFragment of pathFragments) {
		if (url.includes(pathFragment)) {
			return true;
		}
	}
	return false;
}
